import { v4 as uuid } from 'uuid';
import { editBridge, enhanceGLBridge } from '@meitu/wasm-lib';
import { base64Kit } from '@/utils/base64-kit';
import { IImageLayerProps, IImageProps, ILayerProps } from '@/version-types';

/**
 * 应用 gl 的调整效果
 *
 * @param layer - 图层属性
 */
export async function applyEnhanceGLResult(layer: ILayerProps) {
    const isDoEnhance = layer.__isDoEnhance;

    delete layer.__renderEnhanceCanvas;
    delete layer.__isDoEnhance;
    delete layer.__useNavigatorRender;

    if (!isDoEnhance) return;

    let canvas: HTMLCanvasElement | null = null;

    // 逻辑上来说一次 applyEnhanceGLResult 调用只会获取一个 bridge 返回结果
    const bridges = [enhanceGLBridge, editBridge];

    for (const bridge of bridges) {
        const result = await bridge.getGLResult();
        // enhanceGLBridge 初始总会返回一个默认的小画布，所以需要判断宽高是否与图层原始尺寸一致
        if (
            result?.canvas &&
            result?.canvas.width === (layer.data as IImageLayerProps).naturalWidth &&
            result?.canvas.height === (layer.data as IImageLayerProps).naturalHeight
        ) {
            canvas = result.canvas;
            break;
        }
    }

    if (canvas) {
        const base64 = canvas.toDataURL();
        const data = layer.data as IImageProps;
        data.url = base64Kit.getCode(base64, uuid());
    }
}
